//Import REACT components
import React, { Component } from 'react';

//Import admin on rest components
import { GET_LIST } from 'admin-on-rest';

//import custom rest client
import restClient from '../restClient';
import { Card, CardText } from 'material-ui/Card';
//import customerslist component
import AdsSiteSelectorSub from './AdsSiteSelector_Sub';

const styles = {
    flex: { display: 'flex', marginBottom: '1em' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em' },
	h1: {marginTop: '0', color: '#284263', fontSize: '22px' },
	descriptionCard: {marginBottom: '25px' },
	a : {color: '#284263' },
	ol: {paddingLeft: '15px', lineHeight: '25px', fontSize: '110%' },
	cardText: { color: '#555', lineHeight: '23px', padding: '20px 20px 5px 20px' },
	note: {fontSize: '110%', color: 'rgb(224 105 105)'}
};

class AdsSiteSelector extends Component {
   state = {};

   componentDidMount() {
        const d = new Date();
        d.setDate(d.getDate() - 30);
        
		//request data and store in state
        restClient(GET_LIST, 'member/possibleads', {
                filter: { },
                sort: { },
                pagination: { page: 1, perPage: 100 },
            })
            .then(response => response.data)
            .then(domainsList => {
                this.setState({ domainsList });
            })
	
    }
	
	//render component
    render() {
		const {
            domainsList,
        } = this.state;
       	//component HTML
		return (
         <div>
		 	 <Card style={styles.descriptionCard}>
			 	<CardText style={styles.cardText}>
					<h1 style={styles.h1}>Advertentie toevoegen</h1>
					
						<ol style={styles.ol}>
							<li>Kies de voor u relevante sites hieronder en klik op 'Advertentie toevoegen' voor de sites waar u op wilt adverteren.</li>
							<li>Ga naar het menu <strong><a style={styles.a} href="/#/member/ads">mijn advertenties</a></strong> voor een overzicht van uw plaatsingen en wijzigen van de CPC.</li>
							<li>Stel uw bieding per klik (CPC) in. Hoe hoger de CPC hoe hoger u op de website komt te staan. </li>
							<li>Na goedkeuring en plaatsing op onze vergelijkingssites krijgt u bericht en zal uw advertentie actief worden. </li>
							<li>Zodra een bezoeker naar uw website gaat wordt een klik in rekening gebracht. </li>
							<li>De kliks worden aan het begin van iedere maand gefactureerd over voorgaande maand. </li>
						</ol>
		
						<span style={styles.note}>Let op: op dit moment kunt u via deze portal zelf uw CPC beheren en statistieken inzien zoals aantal klikken, CPC en kosten. U kunt niet zelf de inhoud van uw advertentie beheren. U krijgt na aanvraag van een advertentie een e-mail met toegang tot een formulier waar u gegevens zoals website informatie, prijzen, enz. aan kunt leveren. </span>
					
			   </CardText>
			 </Card>
		   	<AdsSiteSelectorSub nb='Recent ontvangen reviews' domains={domainsList} />
         </div>
          
        );
    }
}

export default AdsSiteSelector;



// WEBPACK FOOTER //
// ./src/ads/AdsSiteSelector.js